import { axiosProvider } from '@/app/core/axios';
import {
  EmptyResponse,
  getShortNameForProductToLower,
  ProgramStatus,
  SubmitProgramApiResponse,
} from '@ssar-app/domain';

export const submitHandler = async (
  programName: string,
  productEnum: string,
  draftId: string,
  programId: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>,
): Promise<EmptyResponse> => {
  if (
    programName &&
    programName.trim().length >= 3 &&
    programName.length <= 200
  ) {
    data['status'] = ProgramStatus.Submitted;
    return await submitProgram(
      productEnum,
      data,
      draftId,
      data.dataDictionaryVersion,
    )
      .then((data) => {
        return Promise.resolve(data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  } else {
    return Promise.reject('Program name is required');
  }
};

const submitProgram = (
  productEnum: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any> | undefined,
  draftId: string,
  dataDictionaryVersion = '',
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const newProgram: Record<string, any> = {
    program: data,
    draftId: draftId,
  };
  if (dataDictionaryVersion !== '') {
    newProgram['dataDictionaryVersion'] = dataDictionaryVersion;
  }
  if (data) {
    return new Promise((resolve, reject) => {
      axiosProvider.apiClient
        .post<SubmitProgramApiResponse>(
          `/program/${getShortNameForProductToLower(productEnum)}/save`,
          newProgram,
        )
        .then((response) => {
          if (response) {
            const { data } = response;
            resolve(data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  } else {
    return Promise.reject('Invalid program data.');
  }
};
